var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColumnEdit',{attrs:{"row":_vm.row,"column":_vm.column,"index":_vm.index,"page-info":_vm.pageInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }